// Labels and colours per category id; the ids must match overview_signals.py.

export const TIMEFRAMES = [
  { id: '24h', label: 'Last 24 hours' },
  { id: '7d', label: 'Last 7 days' },
  { id: '30d', label: 'Last 30 days' },
  { id: '90d', label: 'Last 90 days' },
  { id: 'custom', label: 'Custom' },
]

export const DEFAULT_TIMEFRAME = '30d'
export const CUSTOM_TIMEFRAME = 'custom'

// Mirrors MAX_TIMEFRAME_DAYS on the server.
export const MAX_CUSTOM_RANGE_DAYS = 90

// `+N this week` is a fixed 7 days, so a shorter window hides it.
export const WEEKLY_DELTA_MIN_DAYS = 7

// Buckets are daily, so a shorter window has too few bars to be worth drawing.
export const OVER_TIME_MIN_DAYS = 7

export const ALERTS_META = [
  { id: 'device', label: 'New device detected', color: 'var(--chart-blue)' },
  { id: 'hours', label: 'Unusual working hours', color: 'var(--chart-green)' },
  { id: 'travel', label: 'Impossible travel', color: 'var(--chart-yellow)' },
  { id: 'geo', label: 'New geo location', color: 'var(--chart-purple)' },
  { id: 'email_volume', label: 'High-volume sending', color: 'var(--chart-cyan)' },
  { id: 'forwarding', label: 'Mass forwarding', color: 'var(--chart-coral)' },
  { id: 'mailbox_rule', label: 'Suspicious mailbox rule', color: 'var(--chart-mint)' },
  { id: 'session', label: 'Suspicious session', color: 'var(--chart-violet)' },
  { id: 'brute_force', label: 'Failed login attempts', color: 'var(--chart-pink)' },
  { id: 'risky_ip', label: 'Risky IP', color: 'var(--chart-navy)' },
  { id: 'unfamiliar', label: 'Unfamiliar sign-in', color: 'var(--chart-sky-blue)' },
  { id: 'admin_changes', label: 'Admin changes', color: 'var(--chart-orange)' },
  { id: 'other', label: 'Other', color: 'var(--chart-teal)' },
]

export const ALERT_META_BY_ID = ALERTS_META.reduce((acc, meta) => {
  acc[meta.id] = meta
  return acc
}, {})

export const BREAKDOWN_IDS = ALERTS_META.map((a) => a.id)

// An unknown id still has to be drawn, or the donut stops summing to the KPI.
export const alertMeta = (id) =>
  ALERT_META_BY_ID[id] ?? { id, label: id, color: 'var(--chart-teal)' }

// Biggest first, ties by id so equal counts hold their order between requests.
export const bySize = (rows) =>
  [...rows].sort((a, b) => b.count - a.count || a.id.localeCompare(b.id))
